// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ProjectRead } from "./ProjectRead";
import {
  ProjectReadFromJSON,
  ProjectReadFromJSONTyped,
  ProjectReadToJSON,
  ProjectReadToJSONTyped,
} from "./ProjectRead";

/**
 *
 * @export
 * @interface PageProjectRead
 */
export interface PageProjectRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<ProjectRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageProjectRead interface.
 */
export function instanceOfPageProjectRead(value: object): value is PageProjectRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageProjectReadFromJSON(json: any): PageProjectRead {
  return PageProjectReadFromJSONTyped(json, false);
}

export function PageProjectReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageProjectRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(ProjectReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageProjectReadToJSON(json: any): PageProjectRead {
  return PageProjectReadToJSONTyped(json, false);
}

export function PageProjectReadToJSONTyped(
  value?: PageProjectRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(ProjectReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
